<template>
  <div>
    <div class="row">
      <div class="col-md-12 text-right">
        <base-crud
          :ref="'panicosCrud'"
          crudName="Ativações de panico"
          newText=""
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableDownloadPdf="true"
          :enableDownloadExcel="true"
          :enableAdd="false"
          :enableEdit="false"
          :enableDelete="false"
          :enableView="true"
          :enableActive="false"
          :enableReset="false"
          :dataForm="dataForm"
          :customFilters="customFilters"
          @filtered_ds="filtered_ds"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      customFilters: [
        {
          name: "created_at",
          type: "calendar",
          call: "filtered_ds",
        },
      ],
      created_at: "",
      table: "panicosTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "usuario_id", "local_id", "atendido", "responsavel_id", "created_at", "actions"],
      tableData: ["id", "usuario_id", "local_id", "atendido", "responsavel_id", "created_at"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "usuario_id", "local_id", "atendido", 'responsavel_id'],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          usuario_id: "Nome",
          local_id: "Local",
          responsavel_id: "Responsável",
          created_at: "Acionamento",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          atendido:
          [
            {
              id: 0,
              text: 'Não'
            },
            {
              id: 1,
              text: 'Sim'
            },
          ],
        },
        templates: {
          local_id: function (h, row, index) {
            return row.local ? (<span class="badge badge-primary">{row.local.nome}</span>) : (<span class="badge badge-secondary">Não logado / indisponível</span>);
          },
          responsavel_id: function (h, row, index) {
            return row.responsavel ? row.responsavel.name : "Não atribuido";
          },
          usuario_id: function (h, row, index) {
            return row.usuario ? row.usuario.name : "Indisponível";
          },
          atendido: function(h, row, index) {
            if(row.atendido)
            {
              return (<span class="badge badge-primary">Sim</span>);
            }

            return (<span class="badge badge-secondary">Não</span>);
          },
          created_at: function(h, row, index) {
            return row.created_at ? row.created_at_f : "";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;

          if (
            this.$parent.$parent.$parent.created_at != null &&
            this.$parent.$parent.$parent.created_at != ""
          ) {
            requestData.params.created_at =
              this.$parent.$parent.$parent.created_at;
          }

          requestData.params.query = "";
          requestData.params.with = ["local", "responsavel", "usuario"];

          return axios.get(this.url + "?orderByDesc=id&" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "panicos/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    filtered_ds(date) {
      this.created_at = date;
    },
    query: function (query) {
      let columns = {
        id: "id",
        usuario_id: "usuario[name]",
        local_id: "local[nome]",
        responsavel_id :"responsavel[name]",
        atendido: "atendido",
        created_at: "created_at",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>